import React from 'react'
import TestimonialTiles from './TestimonialTiles'
import './TestimonialMain.css'
import myImage from "../../assets/jpg/Testimonial/Image_1.jpg"
import Carousels from 'react-elastic-carousel'

const TestimonialsMain = (props) => {

    const carouselRef = React.useRef(null);
const onNextStart = (currentItem, nextItem) => {
  if (currentItem.index === nextItem.index) {
    carouselRef.current.goTo(0);
  }
};
const onPrevStart = (currentItem, nextItem) => {
  if (currentItem.index === nextItem.index) {
    carouselRef.current.goTo(3);
  }
};
    return (
        <div  className="container-fluid mt-5 pt-5 pb-5 mb-5 testimonial" style = {{display : 'flex' , flexDirection : 'row'}}>
        <div className = 'TestBox' >
        <div className = 'TestHeading'> Testimonials </div>
        <div style = {{display : 'flex' , minHeight : '80px'}}>
        <Carousels
        itemsToScroll = {1} itemsToShow = {1} enableAutoPlay autoPlaySpeed = {1500} className = 'Testcarousel'
        ref = {carouselRef} onPrevStart={onPrevStart} onNextStart={onNextStart} disableArrowsOnEnd={false}
        >
        <TestimonialTiles 
        className="container" 
        image = {myImage}
        myName = "Chirag Maheshwari"
        profile = "https://www.linkedin.com/in/chirag-maheshwari-2b992256/"
        para = { 
            <p className = 'TestEditText3'> 
            Reached out to Wizwack for the development of our full blown product discovery platform. The services have been great and the work is always done on time. Something extremely critical in tech development is quality of work and timelines and wizwack has aced at both. The detailed planning done for every sprint pays off in the long run and there is constant communication with the team as well before delivery of any feature.
            </p>
        }
        designation = { "Co-Founder, Peping Commerce Private Limited"}
        stars = {5}
        />
        </Carousels >
        </div>
        
            
        </div>
            </div>
    )
}

export default TestimonialsMain
